export default __webpack_public_path__ + "static/media/bg-exclusive.d27a8495.webp";